// extracted by mini-css-extract-plugin
export default {"statsCard":"CardContainer_statsCard__YY07M"};